import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface StatementsCardType {
  data: unknown;
  loading: boolean;
  error: string | null;
  get: (cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useStatementsStore = create<StatementsCardType>((set) => ({
  data: null,
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (cardId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.getStatementsCard(cardId, signal);
      set({ data: result ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, error: null }),
}));
